<template>
	<div tabindex="0" @keydown.esc="closeMe" class="popup-block" :class="pageTheme ? 'popup-theme--' + pageTheme : ''">
		<div class="overlay" @click="closeMe"></div>
		<div class="popup-content">
			<button class="close-button" @click="closeMe" v-html="cross">X</button>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { cross } from '@/icons'
import { mapGetters } from 'vuex'

export default {
	name: 'popup',
	data() {
		return {
			cross: cross('#222831'),
		}
	},
	methods: {
		closeMe() {
			this.$emit('close', true)
		},
	},
	metaInfo() {
		return {
			htmlAttrs: {
				class: ['show-popup'],
			},
		}
	},
	computed: {
		...mapGetters(['pageTheme']),
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.popup-block {
	z-index: 9999;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	align-items: center;

	&.popup-theme {
		&--red .popup-content {
			background-color: var(--redLight);
			color: var(--red);
			.close-button {
				path {
					fill: var(--red);
				}
			}
		}
		&--blue .popup-content {
			background-color: var(--blueLight);
			color: var(--blue);
			.close-button {
				path {
					fill: var(--blue);
				}
			}
		}
		&--green .popup-content {
			background-color: var(--greenLight);
			color: var(--green);
			.close-button {
				path {
					fill: var(--green);
				}
			}
		}
		&--purple .popup-content {
			background-color: var(--purpleLight);
			color: var(--purple);
			.close-button {
				path {
					fill: var(--purple);
				}
			}
		}
	}

	&.search-popup,
	&.menu-popup {
		.popup-content {
			background-color: var(--dark);
			color: #fff;
			.close-button {
				path {
					fill: white;
				}
			}
			.slide-hover {
				&.router-link-exact-active {
					&:after {
						transform: scaleX(1);
					}
				}
				&:after {
					background-color: #fff;
				}
			}
		}
	}

	&.menu-popup {
		.popup-nav-block {
			height: 100%;
			display: flex;
			justify-content: space-around;
			align-items: center;
		}
	}

	.popup-content {
		position: relative;
		z-index: 5;
		padding: 75px;
		background-color: var(--gray);
		border-radius: $radius;
		width: 100%;
		max-width: $containerA;
		margin: 20px;
		max-height: 90%;
		overflow-y: auto;
		@include mquery($tablet) {
			padding: 50px;
		}
		@include mquery($phone) {
			padding: 30px;
		}
	}
	.close-button {
		cursor: pointer;
		padding: 5px;
		border: none;
		box-shadow: none;
		background-color: transparent;
		position: absolute;
		top: 50px;
		right: 50px;
		svg {
			width: 25px;
			height: 25px;
		}
		@include mquery($phone) {
			top: 25px;
			right: 25px;
			svg {
				width: 15px;
				height: 15px;
			}
		}
	}
	.overlay {
		cursor: pointer;
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(#fff, 0.79);
	}
}
</style>
